import { api } from '../../api/client';

/** Which page of the embedded DevExpress host is shown. */
export type DesignerMode = 'design' | 'preview';

/** Origin the designer iframe is served from — the API origin in dev
 *  (VITE_API_BASE_URL / localhost:5020), same-origin in the published app. */
export function designerOrigin(): string {
  const base = api.defaults.baseURL ?? '';
  return base ? base.replace(/\/+$/, '') : window.location.origin;
}

/**
 * Builds the iframe URL for a mode / report / designer session:
 *   design  → {origin}/reports/designer?report={name}&rds={token}
 *   preview → {origin}/reports/viewer?report={name}&rds={token}
 * A missing name opens a NEW blank report (designer only).  `rds` is the
 * designer-session capability token (ADR-0014) — sent once; the API forwarder
 * continues from a cookie.
 */
export function designerFrameSrc(mode: DesignerMode, reportName: string | null, token: string): string {
  const page = mode === 'preview' ? 'viewer' : 'designer';
  const q = new URLSearchParams();
  if (reportName) q.set('report', reportName);
  q.set('rds', token);
  return `${designerOrigin()}/reports/${page}?${q.toString()}`;
}
